var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeadphone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4138 17.5967H23.3001V13.2043H24.4138C24.7362 13.2043 25 13.4857 25 13.8296V16.9714C25 17.3153 24.7362 17.5967 24.4138 17.5967ZM2.88687 19.4724C2.56448 19.4724 2.3007 19.2067 2.3007 18.8471V11.9538C2.3007 11.5943 2.56448 11.3286 2.88687 11.3286H3.72216V9.51538C3.72216 4.34148 7.66413 0.152344 12.5 0.152344C17.3505 0.152344 21.2778 4.34148 21.2778 9.51538V11.3286H22.1278C22.4502 11.3286 22.714 11.5943 22.714 11.9538V18.8471C22.714 19.2067 22.4502 19.4724 22.1278 19.4724H19.2702C18.9332 19.4724 18.6841 19.2067 18.6841 18.8471V11.9538C18.6841 11.5943 18.9332 11.3286 19.2702 11.3286H20.1055V9.51538C20.1055 5.04488 16.6911 1.40283 12.5 1.40283C8.30891 1.40283 4.89449 5.04488 4.89449 9.51538V11.3286H5.74443C6.06682 11.3286 6.3306 11.5943 6.3306 11.9538V18.8471C6.3306 19.2067 6.06682 19.4724 5.74443 19.4724H2.88687ZM1.71454 17.5967H0.586167C0.263775 17.5967 0 17.3153 0 16.9714V13.8296C0 13.4857 0.263775 13.2043 0.586167 13.2043H1.71454V17.5967Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeadphone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/headphone.49119fe6a6a0a66cc157912003c8eff6.svg";